import theme from '../../themes/theme';

const { BarcodeScan, ErrorMessage } = theme;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignContent: 'stretch',
    alignItems: 'stretch',
    textAlign: '-webkit-center',
    height: '100%',
  },
  header: {
    display: 'flex',
    flex: 1,
    alignSelf: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    display: 'flex',
    flex: 3,
    alignSelf: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contents: {
    display: 'flex',
    flex: 8,
    alignSelf: 'stretch',
    justifyContent: 'center',
    alignItems: 'flex-start',
    height: '100%',
  },
  actions: {
    display: 'flex',
    flex: 8,
    alignSelf: 'stretch',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleCenter: {
    display: 'flex',
    flexDirection: 'column',
    flex: 6,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    paddingLeft: '0.6em',
  },
  QR_auth_heading: {
    height: '2.0em',
    display: 'flex',
    flex: 2,
    color: BarcodeScan.HeadingFontsColor,
    fontSize: '2.7em',
    fontWeight: '600',
    textAlign: 'center',
    letterSpacing: '-0.031em',
    margin: '0.3em',
  },
  QR_auth_instruction: {
    height: '4.125em',
    color: BarcodeScan.FontsColor,
    display: 'flex',
    flex: 2,
    fontSize: '1.5em',
    fontWeight: 'normal',
    textAlign: 'center',
    letterSpacing: '-0.031em',
  },
  auth_instr: {
    width: '23em',
    display: 'inline-block',
  },
  QRimage: {
    flex: 7,
    display: 'flex',
    width: '18em',
    margin: '0.2em',
  },
  QR_auth_loginByQRCode: {
    color: BarcodeScan.FontsColor,
    fontSize: '1.5em',
    fontWeight: '600',
    height: '2.125em',
    letterSpacing: '-0.031em',
    textAlign: 'center',
    width: '14.85em',
    paddingRight: '2em',
    paddingTop: '2em',
  },
  errorMessage: {
    color: ErrorMessage.HeadingFontsColor,
    fontSize: '2.8em',
    position: 'absolute',
    height: '2.8em',
    top: '54%',
    left: '46%',
    marginLeft: '-3em',
    marginTop: '-3em',
    background: ErrorMessage.BackgroundColor,
  },
  errorMessage_info: {
    color: ErrorMessage.FontsColor,
    fontSize: '1.5em',
    position: 'absolute',
    height: '3.6em',
    top: '56%',
    left: '46%',
    marginLeft: '-6.3em',
    marginTop: '-3em',
  },
  loading: {
    position: 'fixed',
    top: '33%',
    left: '41%',
  },
};

export default styles;
